import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { CONTACT_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';

// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { contactPageFaqItems } from '../../utils/data/faqSchemas';

function ContactPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Contact', href: CONTACT_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName="Contact"
        desc={`Submit your tribute and request an audience with ${CompanyName}. Approach with respect, clarity, and proper obedience.`}
        keywords={KeywordsPages}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={[contactPageStructuredData, breadcrumbLd]}
        canonicalPath={CONTACT_PAGE_URL}
      />

      {/* Page */}
      <div className="grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1">
        <div className="grid min-h-screen">
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className="pt-24 px-6 lg:container lg:mx-auto lg:px-24">
            <h1
              aria-label={`Contact ${CompanyName}`}
              className="text-center font-titleFont text-6xl lg:text-6xl tracking-widest"
            >
              Contact Me
            </h1>

            <div className="mx-auto grid justify-center uppercase tracking-wider text-xl text-center mt-1">
              <h2>Book A Session</h2>
            </div>

            <div className="mx-auto grid justify-center px-4 text-center mt-2">
              <p className="pt-2 text-sm max-w-xl mx-auto leading-relaxed">
                When addressing Me, use only <strong>Queen</strong>,{' '}
                <strong>Goddess</strong>, <strong>Mommy</strong>,{' '}
                <strong>Empress</strong>, <strong>Sir</strong>,{' '}
                <strong>Daddy</strong>, or <strong>Master</strong>. I do{' '}
                <strong>not</strong> respond to <strong>Princess</strong> or{' '}
                <strong>Mistress</strong>. Any message ignoring this rule will be
                deleted without reply.
              </p>
            </div>
          </header>

          {/* Main page content */}
          <ContactPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={contactPageFaqItems} />
      </div>
    </>
  );
}

export default ContactPage;
